import React, { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

const Expenseshistory = ({clientData}) => {
const navigate = useNavigate();
const[expenseBill,setExpenseBill] = useState([])
  const [searchTerm, setSearchTerm] = useState('');

 
const fetchExpense = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-expense-bill/${clientData.id}`);
     
      const sortedData = [...res.data].sort((a, b) => b.invoiceNo - a.invoiceNo);

    setExpenseBill(sortedData);
     
    } catch (error) {
      console.log(error);
    }
  };   

   useEffect(() => {
     fetchExpense();
  
    }, []);

    const filteredData = Array.isArray(expenseBill)
  ? expenseBill
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
  : [];
  return (
    
    <div className="container-fluid py-4">
      <div className="card shadow border-0 rounded-4">
     <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
  <h4 className="mb-0 fw-bold">
    Expense History
  </h4>

  <button className="btn btn-primary"
    onClick={() => navigate("/expenses")}
  >
    Back
  </button>
</div>
       

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead >
                <tr>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv.No</th>
                    <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Category</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Description</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Date Time</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>PayMode</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Paid</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Activity</th>
                </tr>
              </thead>

              <tbody>
                   {filteredData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center text-muted">
            No Transaction Found
          </td>
        </tr>
      ) : (
        filteredData.map((item, index) => (
          <tr key={item.id}>
            <td>{item.invoiceNo}</td>
            <td>{item.category}</td>
            <td>{item.description} </td>
            <td>{item.date}</td>
            <td>{item.mode}</td>
            <td> ₹{item.paid || 0}</td>
        
        <td> 

           <button className="btn btn-primary " 
           onClick={() =>
    navigate("/expenses", {
      state: item,
    })
  }
           >
         Edit
          </button>
        </td>
          </tr>
        ))
      )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expenseshistory;
